<template>
    <Card v-bind="options">
        <ToggleItem v-for="(filter,index) in filtersCopy " :key="index" v-bind="filter" @input="getSelectedChilds(filter.name, ...arguments)" :paddingY='.3' @handleClick="fireStar(filter.name)"/>
    </Card>
</template>

<script>
import ToggleItem from '../ToggleNav.vue'
import Card from '../Card.vue'
export default {
    components: { ToggleItem, Card},
    props : {
        filtersList : { type : Array, default : null},
    },
    data() {
        return {
            options :{
                padding : { x : 0, y : 1},
                rounded : .5,
                boxShadow : {x : 5, y : 5, blur : 1, color : '#e5e5e526'},
                hasHeader : false,
                hasfooter : false,
                border : { width: .1, color : '#b6cad8', style : 'solid'},
               // height : 'auto',
                main : { 
                    padding : 0
                }
            },
            starred : false,
            shared : false,
            items : [
                {
                    title : 'Organization',
                    name : 'organization',
                    icon : 'organization',
                    childrens: []
                },
                {
                    title : 'Author',
                    name : 'author',
                    icon : 'author',
                    childrens: []
                },
                {
                    title : 'Experience',
                    name : 'experience',
                    icon : 'experience',
                    childrens: []
                },
                {
                    title : 'Starred',
                    name : 'starred',
                    icon : !this.starred ? 'starred' :'author',
                    childrens: null,
                    iconAfter : false,
                    toggle : false,
                    isStarred : this.starred 
                },
                {
                    title : 'Shared with me',
                    name : 'shared',
                    icon : !this.shared ? 'share' :'author',
                    childrens: null,
                    iconAfter : false,
                    toggle : false,
                    isShared : this.shared 
                },
            ],
            activeFilters:[],
        }
            
    },
    mounted () {
       if(this.filtersList) this.items = this.filtersList;
       this.activeFilters =  this.$store.state.filters;
    },

    computed : {
        filtersCopy() {
            if(this.starred) {this.items[3].icon = 'starred'}
            else{this.items[3].icon = 'noStarred'}
            if(this.shared){ this.items[4].icon = 'share'}
            else {this.items[4].icon = 'noShare'}
            return this.items
        },
    },
    methods : {
        getSelectedChilds(filterName,childs){
            if(childs.length > 0 ) {
                let index = this.activeFilters.findIndex(element => element.name == filterName)
                if(index == -1) this.activeFilters.push({name : filterName, children : childs});
                else this.activeFilters[index].children = childs;
            }
            else  this.activeFilters = this.activeFilters.filter(  item => item.name != filterName); 

            let index =  this.$store.state.filters.findIndex(element => element.name == 'starred')
            if(index != -1) this.activeFilters.push(this.$store.state.filters[index]);

            this.$store.state.filters =  this.activeFilters; 
        },
        fireStar(element){
            if(element == 'starred'){ this.starred = !this.starred;
            let index =  this.$store.state.filters.findIndex(element => element.name == 'starred')
            if(index == -1) this.$store.state.filters.push({ name : this.items[3].name, isStarred : true});
            else  this.$store.state.filters.splice(index, 1)
            }else if(element == 'shared'){this.shared = !this.shared;
            let index =  this.$store.state.filters.findIndex(element => element.name == 'shared')
            if(index == -1) this.$store.state.filters.push({ name : this.items[4].name, isShared : true});
            else  this.$store.state.filters.splice(index, 1)
            }

        },
 
    }
}
</script>




// WEBPACK FOOTER //
// src/components/global/sections/GalleryFilter.vue